<template>
  <v-page page="Charges" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-3 style="min-height: 46px;">
                  <v-flex align-center>
                    <div
                      v-show="BAN == 'all'"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Charges</div>
                    <div
                      v-show="showResetBtn && !loading && BAN !== 'all'"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Charges for Account # {{ BAN }}</div>
                  </v-flex>
                  <v-flex align-center xs8>
                    <v-layout row>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlServiceType"
                          v-model="filters.ServiceType"
                          item-text="Text"
                          item-value="Text"
                          label="Service Type"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlChargeType"
                          v-model="filters.ChargeType"
                          item-text="Text"
                          item-value="Text"
                          label="Charge Type"
                          clearable
                          @change="filterServices"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs3 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterServices"
                          ></v-text-field>
                          <v-btn @click="filterServices" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- <v-btn class="TierButton mb-1 mr-2 ml-1" @click="exportToExcel">
                        <v-icon>fa-file-excel</v-icon> &nbsp; Excel
                      </v-btn>-->
                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="exportToExcel"
                      >EXCEL</a>
                      <v-btn
                        class="TierButton mb-1 mr-0 ml-1"
                        :to="openCreateChargeRoute()"
                      >+ New Charge</v-btn>
                      <createCharge ref="createCharge"></createCharge>
                      <editCharge ref="editCharge"></editCharge>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->
                <!-- Charges Table -->
                <v-data-table
                  :headers="headers"
                  :items="charges"
                  :item-key="charges.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <router-link
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(props.item)"
                        >
                          <text-highlight
                            :queries="searchHighlight"
                          >{{ props.item["AccountNumber"] }}</text-highlight>
                        </router-link>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">
                          {{
                          (props.item["AccountName1"] + ' ' +
                          (props.item["AccountName2"] == null ? "" :props.item["AccountName2"])
                          ).trim() }}
                        </text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">{{ props.item["ServiceType"] | uppercase}}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["ServiceType"] === 'Wireless' && props.item["ElementType"] !="MDN" ? formatPN_helper(props.item["ServiceIdentifier"]) : props.item["ElementType"] =="MDN"? formatSIM(props.item["ServiceIdentifier"]): props.item["ServiceIdentifier"] }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ formatSIM(props.item["SecondaryIdentifier"]) }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["ChargeDescription"] | uppercase }}</text-highlight>
                      </td>
                      <td
                        :class="{'justify-end text-xs-right pr-2 pt-0 pb-0': props.item.ChargeAmount >= 0, 'justify-end text-xs-right pr-2 pt-0 pb-0 red--text': props.item.ChargeAmount < 0}"
                      >
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ formatCurrency(props.item["ChargeAmount"]) }}</text-highlight>
                      </td>
                      <td class="text-xs-center px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ formatDate(props.item["StartDate"]) }}</text-highlight>
                      </td>
                      <td class="text-xs-center px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ formatDate(props.item["EndDate"]) }}</text-highlight>
                      </td>
                      <td class="text-xs-center pl-0 pr-2" :class="{'red--text': props.item.IsExpired === true, 'green--text': props.item.IsExpired === false}">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["IsExpired"] == true ? "YES":"NO" }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0" :class="{'purple--text': props.item.ChargeFrequency === 'Monthly', 'orange--text': props.item.ChargeFrequency === 'One-time'}">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["ChargeFrequency"] | uppercase }}</text-highlight>
                      </td>
                      <td class="text-xs-right px-0">
                        <router-link
                          class="mr-2"
                          style="text-decoration: none"
                          :to="openEditChargeRoute(props.item)"
                        >EDIT</router-link>
                        <router-link
                          class="mr-0"
                          style="text-decoration: none"
                          :to="openChargeAuditLogs(props.item)"
                        >LOG</router-link>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                </v-data-table>
                <!-- END Charges Table-->

                <v-btn
                  color="primary"
                  @click="resetChargesList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import createCharge from "./CreateCharge";
import editCharge from "./EditCharge";
import TextHighlight from "vue-text-highlight";
import "@/assets/css/main.css"
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Charges",

  components: {
    VPage,
    createCharge,
    editCharge,
    "text-highlight": TextHighlight,
    DataTablePagination
  },

  data: () => ({
    BAN: "",
    showResetBtn: false,
    dialog: false,
    search: "",
    loading: true,
    filtersChanged: false,
    totalRecords: 0,

    filters: {},

    ddlServiceType: [],
    ddlChargeType: [],

    searchHighlight: "",

    breadcrumb: [
      {
        text: "Charges",
        disabled: false,
        href: "#/charges/all"
      },
      {
        text: "All",
        disabled: true,
        href: "#/charges/all"
      }
    ],

    pagination: {
      rowsPerPage: 30,
      descending: false,
      sortBy: "AccountNumber"
    },

    loading: false,

    rowsPerPageItems: [30, 45, 60],

    headers: [
      {
        text: "BAN",
        value: "AccountNumber",
        width: "4%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Name",
        value: "AccountName",
        width: "21%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Service",
        value: "ServiceType",
        width: "7%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Service ID",
        value: "ServiceIdentifier",
        width: "9%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Secondary ID",
        value: "SecondaryIdentifier",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },
      {
        text: "Charge",
        value: "ChargeDescription",
        width: "19%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Amount",
        value: "ChargeAmount",
        width: "7%",
        fixed: true,
        align: "right",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },
      {
        text: "Effective Date",
        value: "StartDate",
        width: "9%",
        fixed: true,
        align: "center",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Expiry Date",
        value: "EndDate",
        width: "9%",
        fixed: true,
        align: "center",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Expired?",
        value: "IsExpired",
        width: "9%",
        fixed: true,
        align: "center",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },
      {
        text: "Frequency",
        value: "ChargeFrequency",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Action",
        width: "7%",
        sortable: false,
        fixed: true,
        align: "right",
        class: "pl-0 pr-0 font-weight-bold subheading"
      }
    ],

    charges: []
  }),

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  filters: {
    uppercase: function(item) {
      if (item) {
        return item.toUpperCase();
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.path== from.path) {
      if (to.query.ChargeId != null) {
        var ChargeId = to.query.ChargeId;
        this.openEditChargeForm({
          ChargeId: ChargeId
        });
      }
      if (to.query.createCharge != null) {
        this.openCreateChargeForm();
      }
    }
      next()
  },

  methods: {
    async initialize() {
      this.loading = true;
      this.filters = {};

      this.BAN = this.$route.params.BAN;

      if (this.$route.query.search != null){
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
      }

      this.pagination.page = 1;
      this.pagination.rowsPerPage = 30;

      if (this.BAN !== "all") {
        this.filters = {
          AccountNumber: this.BAN
        };

        this.filtersChanged = true;

        this.breadcrumb[1].text = this.BAN;
        this.showResetBtn = true;
      } else {
        this.breadcrumb[1].text = "all";
        this.filters = {};
        this.filtersChanged = true;
        this.showResetBtn = false;
      }

      this.getDropdownOptions(
        "/api/Charge/GetServiceTypeDdl",
        "ddlServiceType"
      );
      this.getDropdownOptions("/api/Charge/GetChargeTypeDdl", "ddlChargeType");

      var paginationUpdated = await this.paginationUpdated();

      if (this.$route.query.ChargeId != null) {
        var ChargeId = this.$route.query.ChargeId;
        this.openEditChargeForm({
          ChargeId: ChargeId
        });
      }
      if (this.$route.query.createCharge != null) {
        this.openCreateChargeForm();
      }

      this.loading = false;
    },
    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    openAccountSummaryPage(item) {
      return "/account-summary/" + item.AccountNumber;
    },
    formatCurrency(value) {
      var absValue = Math.abs(value);
      var returnString = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(absValue);

      return value < 0 ? "(" + returnString + ")" : returnString;
    },
    formatDate(value) {
      if (value) return moment(value).format("YYYY-MM-DD");
      else return "";
    },
    async filterServices() {
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery()
      await this.paginationUpdated();
    },
    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Charge/GetPagedChargeList/",
          {
            postData: {
              pagination: this.pagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.charges = response.data.charges;
          this.totalRecords = response.data.totalRecords;
        });
      this.loading = false;
    },
    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },
    async resetChargesList() {
      this.loading = true;
      this.$router.push("/charges/all");
      this.pagination.totalRecords = 0;
      this.filters = {};
      this.searchHighlight = "";
      this.search = "";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
      this.breadcrumb[1].text = "all";
    },

    openCreateChargeForm() {
      this.$refs.createCharge.open({ BAN: this.BAN });
      this.deleteQueryString('createCharge')
    },

    async openEditChargeForm(item) {
     await this.$refs.editCharge.open({
        ChargeId: item.ChargeId.toString()
      });

      this.deleteQueryString('ChargeId')
    },
    openEditChargeRoute(item){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.ChargeId = item.ChargeId
      return {path: path, query: newQuery}
    },
    openCreateChargeRoute(item){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query

      var newQuery = Object.assign({}, query)
      newQuery.createCharge = this.BAN
      return {path: path, query: newQuery}
    },
    openChargeAuditLogs(item) {
      var BAN = item.AccountNumber;
      var ServiceId = item.ServiceId ? item.ServiceId.toString() : "all";
      var ChargeId = item.ChargeId;
      return "/log/charge/" + BAN + "/" + ServiceId + "/" + ChargeId;
    },
    deleteQueryString(queryString){
      let query = Object.assign({}, this.$route.query);
      delete query[`${queryString}`];
      this.$router.replace({ query });
    },
    exportToExcel() {
      var params = {
        account: this.BAN,
        filters: this.filters,
        search: this.search
      };
      axios({
        url: "/api/Excel/charges/",
        method: "POST",
        data: params,
        responseType: "blob"
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Charges.xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
     formatPN_helper(num) {
       if (num){
         let formattedNum =
        "(" + num.slice(0, 3) + ") " + num.slice(3, 6) + "-" + num.slice(6);
      return formattedNum;
       }
    },
    formatSIM(num) {
      if (num ){
        let res = [...num].map((d, i) => (i) % 5 == 0 ? ' ' + d : d).join('').trim()
      return res;
      }
    },
    updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
